import type { AuthPermissionUser } from '../../services/authPermissions';

// ORDER_STAFF = Handlowiec: full product master data (decision 2026-09-23).
const PRODUCT_CATALOG_MANAGEMENT_ROLES = ['ADMIN', 'OPERATIONS', 'ORDER_STAFF'];

export function canManageProductCatalog(user: AuthPermissionUser | null | undefined): boolean {
  return PRODUCT_CATALOG_MANAGEMENT_ROLES.includes(user?.role || '');
}

export function canDeleteProductCatalogItem(user: AuthPermissionUser | null | undefined): boolean {
  return PRODUCT_CATALOG_MANAGEMENT_ROLES.includes(user?.role || '');
}
